<template lang="html">
  <div class="province-F">
    <!-- <div class="ttBar">
      <span>出版经营情况统计</span>
      getPublicationStatisticList
    </div> -->
    <div class="tabArea">
      <div class="seekArea">
        <div class="selectBox">
          <span>资质：</span>
          <el-select v-model="selType" size="small" placeholder="请选择" style="width: 80px">
            <el-option v-for="item in Zizhi" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="selectBox">
          <span>省局：</span>
          <el-select v-model="selProvinceId" size="small" placeholder="请选择" clearable style="width: 230px">
            <el-option v-for="item in Shengju" :key="item.sjExamineId" :label="item.sjExamine" :value="item.sjExamineId">
            </el-option>
          </el-select>
        </div>
        <!-- <div class="selectBox">
          <span>排序：
          </span>
          <el-select v-model="selOrder" size="small" placeholder="请选择" clearable @change="tabSeek">
            <el-option v-for="item in OrderBy" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <el-select v-model="selSort" size="small" placeholder="请选择" clearable @change="tabSeek">
            <el-option v-for=" item in Sort" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div> -->
        <div class="selectBox">
          <span>年份：</span>
          <el-select v-model="selYear" size="small" placeholder="历年记录" style="width: 120px">
            <el-option v-for="item in selYearRecord" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="selectBox">
          <el-button size="small" type="primary" @click="goSeek" :loading="loading">搜索</el-button>
          <el-button size="small" type="primary" plain style="margin-left: 10px" @click="goExport">导出</el-button>
        </div>
      </div>
      <el-table :data="tabDats" style="width: 100%" border @sort-change="this.handleSortChange" :height="this.tableHeight">
        <el-table-column prop="organizationName" label="出版单位" width="180" fixed>
        </el-table-column>
        <el-table-column prop="provinceName" label="所属省局" width="180">
        </el-table-column>
        <el-table-column :label="selYear + '年'">
          <el-table-column prop="firstTotalSales" label="出版单位年销售收入（万元）" width="230" sortable="custom">
          </el-table-column>
          <el-table-column prop="firstTotalProfit" label="出版单位年利润收入（万元）" width="230" sortable="custom">
          </el-table-column>
          <el-table-column prop="firstSales" :label="(selType == 1 ? '音像制品' : '电子出版物') + '年销售收入（万元）'" width="230" sortable="custom">
          </el-table-column>
          <el-table-column prop="firstProfit" :label="(selType == 1 ? '音像制品' : '电子出版物') + '年利润总额（万元）'" width="230" sortable="custom">
          </el-table-column>
          <el-table-column prop="firstPublicationVariety" label="出版物品种数量" width="200" sortable="custom">
          </el-table-column>
        </el-table-column>
        <el-table-column :label="(selYear * 1 + 1) + '年'">
          <el-table-column prop="secondTotalSales" label="出版单位年销售收入（万元）" width="230" sortable="custom">
          </el-table-column>
          <el-table-column prop="secondTotalProfit" label="出版单位年利润收入（万元）" width="230" sortable="custom">
          </el-table-column>
          <el-table-column prop="secondSales" :label="(selType == 1 ? '音像制品' : '电子出版物') + '年销售收入（万元）'" width="230" sortable="custom">
          </el-table-column>
          <el-table-column prop="secondProfit" :label="(selType == 1 ? '音像制品' : '电子出版物') + '年利润总额（万元）'" width="230" sortable="custom">
          </el-table-column>
          <el-table-column prop="secondPublicationVariety" label="出版物品种数量" width="200" sortable="custom">
          </el-table-column>
        </el-table-column>
      </el-table>
    </div>
  </div>
</div></template>

<script>
import { getProviceList, getPublicationStatisticList } from '@/api/adminRole/adminRole';
import { getSelYearRecord } from '@/api/pressRole/pressRole';
import { outExcel } from "@/utils/Export";

export default {
  data() {
    return {
      selYear: '',

      selType: "1",
      Zizhi: [{
        value: '1',
        label: '音像'
      }, {
        value: '2',
        label: '电子'
      }],

      selProvinceId: undefined,
      Shengju: [],

      selOrder: undefined,
      OrderBy: [{
        value: 'firstTotalSales',
        label: this.selYear + '年销售收入'
      }, {
        value: 'firstTotalProfit',
        label: this.selYear + '年利润总额'
      }, {
        value: 'firstSales',
        label: this.selYear + '年' + (this.selType == 1 ? '音像制品' : '电子出版物') + '销售收入'

      }, {
        value: 'firstProfit',
        label: this.selYear + '年' + (this.selType == 1 ? '音像制品' : '电子出版物') + '利润总额'

      }, {
        value: 'firstPublicationVariety',
        label: this.selYear + '年出版品种数量'
      }, {
        value: 'secondTotalSales',
        label: (this.selYear * 1 + 1) + '年销售收入'

      }, {
        value: 'secondTotalProfit',
        label: (this.selYear * 1 + 1) + '年利润总额'

      }, {
        value: 'secondSales',
        label: (this.selYear * 1 + 1) + '年' + (this.selType == 1 ? '音像制品' : '电子出版物') + '销售收入'

      }, {
        value: 'secondProfit',
        label: (this.selYear * 1 + 1) + '年' + (this.selType == 1 ? '音像制品' : '电子出版物') + '利润总额'

      }, {
        value: 'secondPublicationVariety',
        label: (this.selYear * 1 + 1) + '年出版品种数量'
      }],

      selSort: "asc",
      Sort: [{
        value: 'asc',
        label: '正序'
      }, {
        value: 'desc',
        label: '倒序'
      }],


      tabDats: [],
      params: {
        year1: ""
      },
      tableHeight: 250,
    }
  },

  methods: {
    tabSeek: function (type) {
      this.loading = true;
      this.params = {
        type: this.selType,
        provinceId: this.selProvinceId,
        order: this.selOrder,
        sort: this.selSort,
        year: this.selYear,
      }
      let vm = this;
      console.log(this.params)

      getPublicationStatisticList(this.params).then(response => {
        console.debug('getPublicationStatisticList: ', response)
        setTimeout(function () {
          vm.loading = false;
          vm.tabDats = response.publicationStatisticList;
        }, 300)
      })
    },
    handleSortChange: function (column) {
      this.selOrder = column.prop;

      var sort = undefined;
      if (column.order == 'ascending') {
        sort = 1;
      } else if (column.order == 'descending') {
        sort = 0;
      }
      this.selSort = sort;
      console.log(this.selOrder, this.selSort, column)
      this.tabSeek();
    },
    goFirm: function (rows) {
      this.$router.push({
        path: 'successive_skim',
        query: {
          pressId: rows.organizationId,
          pvcName: rows.sjExamine,
          pvcId: rows.sjExamineId,
          listId: rows.id,
          bookName: rows.name,
          pressName: rows.organizationName,
          mtId: rows.materialExamineId,
          examId: rows.materialExamineId,
          pressState: 3,
          year1: this.selYear
        }
      })
    },
    pageSent: function (inx) {
      this.params.no = inx;
      this.tabSeek();
    },
    goSeek: function () {
      this.params.no = 1;
      this.params.year1 = this.selYear || '';
      this.pgAll = 0;
      this.tabSeek();
    },
    provinceSet: function () {
      let vm = this;
      getProviceList({
        type: this.selType
      }).then(response => {
        vm.Shengju = response.proList;
      });
    },
    getOrderByList: function (year, type) {
      return [{
        value: 'firstTotalSales',
        label: year + '年销售收入'
      }, {
        value: 'firstTotalProfit',
        label: year + '年利润总额'
      }, {
        value: 'firstSales',
        label: year + '年' + (type == 1 ? '音像制品' : '电子出版物') + '销售收入'

      }, {
        value: 'firstProfit',
        label: year + '年' + (type == 1 ? '音像制品' : '电子出版物') + '利润总额'

      }, {
        value: 'firstPublicationVariety',
        label: year + '年出版品种数量'
      }, {
        value: 'secondTotalSales',
        label: (year * 1 + 1) + '年销售收入'

      }, {
        value: 'secondTotalProfit',
        label: (year * 1 + 1) + '年利润总额'

      }, {
        value: 'secondSales',
        label: (year * 1 + 1) + '年' + (type == 1 ? '音像制品' : '电子出版物') + '销售收入'

      }, {
        value: 'secondProfit',
        label: (year * 1 + 1) + '年' + (type == 1 ? '音像制品' : '电子出版物') + '利润总额'

      }, {
        value: 'secondPublicationVariety',
        label: (year * 1 + 1) + '年出版品种数量'
      }]
    },
    getHeight() {
      var header = document.getElementsByClassName("seekArea")[0].clientHeight;
      console.log("Resize:", header);
      this.tableHeight = document.documentElement.clientHeight - header - 120;

      console.log("Resize:", this.tableHeight);
    },
    goExport: function () {
      var that = this;
      var params = {
        type: this.selType,
        // provinceId: this.selProvinceId,
        // order: this.selOrder,
        // sort: this.selSort,
        year: this.selYear,
      };
      getPublicationStatisticList(this.params).then(response => {
        var filename = "出版经营情况统计";
        var cols = [{
          title: '出版单位',
          dataIndex: 'organizationName'
        }, {
          title: '所属省局',
          dataIndex: 'provinceName'
        }, {
          title: this.selYear + '年销售收入（万元）',
          dataIndex: 'firstTotalSales'
        }, {
          title: this.selYear + '年利润总额（万元）',
          dataIndex: 'firstTotalProfit'
        }, {
          title: this.selYear + '年' + (this.selType == 1 ? '音像制品' : '电子出版物') + '销售收入（万元）',
          dataIndex: 'firstSales'
        }, {
          title: this.selYear + '年' + (this.selType == 1 ? '音像制品' : '电子出版物') + '利润总额（万元）',
          dataIndex: 'firstProfit'
        }, {
          title: this.selYear + '年出版品种数量',
          dataIndex: 'firstPublicationVariety'
        }, {
          title: (this.selYear * 1 + 1) + '年销售收入（万元）',
          dataIndex: 'secondTotalSales'
        }, {
          title: (this.selYear * 1 + 1) + '年利润总额（万元）',
          dataIndex: 'secondTotalProfit'
        }, {
          title: (this.selYear * 1 + 1) + '年' + (this.selType == 1 ? '音像制品' : '电子出版物') + '销售收入（万元）',
          dataIndex:'secondSales'
        }, {
          title: (this.selYear * 1 + 1) + '年' + (this.selType == 1 ? '音像制品' : '电子出版物') + '利润总额（万元）',
          dataIndex:'secondProfit'
        }, {
          title: (this.selYear * 1 + 1) + '年出版品种数量',
          dataIndex:'secondPublicationVariety'
        }
        ];
        var wsname = "出版经营情况统计";
        outExcel(response.publicationStatisticList, cols, filename, wsname);
      });
    },
  },

  created: function () {
    this.provinceSet();
    let that = this;
    getSelYearRecord({
      publishId: '',
      type: 3,
    }).then(response => {
      console.log("======", response);
      var arr = [];
      if (response.generalPublisher.length > 0) {
        for (var i in response.generalPublisher) {
          var po = response.generalPublisher[i];
          arr.push({ label: po.firstYear + '~' + po.secondYear, value: po.firstYear });
          if ((response.generalPublisher.length - 1) == i) {
            that.params.year1 = po.firstYear;
            that.selYear = po.firstYear;

            that.OrderBy = that.getOrderByList(that.selYear, that.selType);
          }
        }
      }
      that.selYearRecord = arr;
      that.tabSeek();
    })
    window.addEventListener("resize", this.getHeight);
  },
  mounted: function () {
    this.$nextTick(() => {
      this.getHeight();
    });
  },
  destroyed: function () {
    window.removeEventListener("resize", this.getHeight);
  },
}
</script>

<style lang="scss" scoped>
.province-F {
  padding: 9px;

  .ttBar {
    height: 45px;
    line-height: 45px;
    background: #F8F8F8;
    font-size: 14px;
    padding: 0 20px;
    color: #666666;
    font-weight: bold;
  }

  .tabArea {
    margin-top: 12px;

    .seekArea {
      margin-bottom: 12px;
      overflow: hidden;
      .selectBox {
        padding-left: 10px;
        float: left;
      }

      .el-input {
        input {
          border-radius: 0px;
        }
      }
    }

    .pageCage {
      text-align: center;
      margin: 30px auto;
    }
  }
}
</style>



// WEBPACK FOOTER //
// adminPublishOperation.vue?1d198f27